module.exports = __webpack_public_path__ + "static/media/image.82ccdfb5.jpg";